import React from 'react';
import Chip from 'Chip';
import styles from './index.css';
import PropTypes from 'prop-types';

/**
 * 定义 Navigation 组件
 */
class Navigation extends React.PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            platformSubShow: { display: 'none' },
            current: '',
        };
    }
    mouseMoveHandler = () => {
        this.setState({
            platformSubShow: { display: 'block' },
        });
    };
    mouseLeaveHandler = () => {
        this.setState({
            platformSubShow: { display: 'none' },
        });
    };
    componentDidMount = () => {
        this.selectCurrentNav();
    };
    selectCurrentNav = () => {
        const path = window.location.pathname.split('/').pop();

        console.log('path==', path);
        // 待完成current li
        const oul = document.getElementById('navUl');
        const oli = Array.from(oul.querySelectorAll('li'));

        oli.forEach((currentLi, index) => {
            if (index === this.props.current) {
                currentLi.style.background = '#000';
            }
            const currentA = currentLi.querySelector('a');
            const navPath = currentA.href.split('/').pop();

            if (navPath === path) {
                currentLi.style.background = '#000';
            }
        });
    };
    /**
     * 渲染组件
     */
    render() {
        const { content } = this.props;

        const navList = content.map((currentNav, index) => {
            let subNav = null;
            let eachLi = null;

            if (currentNav.children) {
                subNav = currentNav.children.map((currentSub, subIndex) => {
                    return (
                        <li key={subIndex}>
                            <a href={currentSub.url} target="_blank" rel="noopener noreferrer">
                                {currentSub.title}
                            </a>
                        </li>
                    );
                });
                eachLi = (
                    <li
                        className={styles.hasSub}
                        id="hasSub"
                        key={index}
                        onMouseMove={this.mouseMoveHandler}
                        onMouseLeave={this.mouseLeaveHandler}>
                        <a href={currentNav.url} target="_blank" rel="noopener noreferrer">
                            {currentNav.title}
                        </a>
                        <ul className={styles.subNav} id="subNav" style={this.state.platformSubShow}>
                            {subNav}
                        </ul>
                    </li>
                );

                return eachLi;
            } else {
                eachLi = (
                    <li key={index} className={this.state.current}>
                        <a href={currentNav.url} target="_blank" rel="noopener noreferrer">
                            {currentNav.title}
                        </a>
                    </li>
                );

                return eachLi;
            }
        });

        return (
            <div className={styles.navBox}>
                <ul id="navUl" className={styles.navUl}>
                    {navList}
                </ul>
            </div>
        );
    }
}

/**
 * 定义组件属性类型
 * */
Navigation.propTypes = { content: PropTypes.array, current: PropTypes.number };

/**
 * 定义组件默认属性
 * */
Navigation.defaultProps = {};

export { Navigation };
export default Navigation;
